<template>
    <section>
      Priority
      <vue-form-generator
        :schema="schemaSkipBlacklist"
        :model="skipBlacklist"
        @model-updated="changeSwitch()"
      />
    </section>
</template>

<script>
import { targetsService } from "@/_services";


export default {
  data() {
    return { 
        loaded:false,
        skipBlacklist: {
          priority: false,
        },
        schemaSkipBlacklist: {
        fields: [
          {
            type: "switch",
            model: "priority",
            featured: true,
            id: "priority",
            textOn: "",
            textOff: "",
            valueOn: true,
            valueOff: false,
            styleClasses: "col-md-12 my-0",
          }
        ]
      },
    }
  },

  props: {
    target_id:false,
    typelist:false
  },

  created() {
    this.skipBlacklist.priority=false;
     if(this.typelist == 9){
      this.skipBlacklist.priority= true;
    }
    
  },

  methods: {
    insertPriority(type){
      targetsService.insertPriority(this.target_id,type).then((result) => {});
    },  
    changeSwitch(){
      if(this.skipBlacklist.priority){
        this.insertPriority("add")
      }else{
        this.insertPriority("delete")
      }
    }
  }

}
</script>